// https://github.com/hilongjw/vue-lazyload#readme
import Vue from 'vue'
import VueLazyload from 'vue-lazyload'
// or with options

// var userAgent = window.navigator.userAgent;
// console.log("客户端环境", userAgent)
// if (userAgent.indexOf('NET') != -1) {
//   //ie浏览器不兼容懒加载组件处理
//   console.log("lazy", Vue.directive)
//   Vue.directive('lazy', function (el, binding) {
//     console.log("v-lazy", el, binding)
//     el.src = binding.value
//   })
// } else {
// var userAgent = window.navigator.userAgent;
// if (userAgent.indexOf('NET') != -1) {
//   console.log("客户端环境", userAgent)
//   //ie浏览器不兼容懒加载组件处理
//   // Vue.directive('lazy', function (el, binding) {
//   //   console.log("v-lazy", el, binding)
//   //   el.src = binding.value
//   // })

// }
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'https://oss-resource668.yzdli.com/website/image/result/image_error.png',
  loading: 'https://oss-resource668.yzdli.com/website/image/result/image_loading.png',
  // listenEvents: ["scroll"],
  // dispatchEvent:true,
  // 重试次数
  attempt: 3,
  // 不打印调试信息
  // silent: false,
  observer: true,
  // optional
  observerOptions: {
    rootMargin: '0px',
    threshold: 0.1,
  },
  adapter: {
    loaded({ bindType, el, naturalHeight, naturalWidth, $parent, src, loading, error, Init }) {
      // console.log('loaded', naturalWidth, naturalHeight)
      // console.log(
      //   'loaded-el',
      //   bindType,
      //   el,
      //   naturalHeight,
      //   naturalWidth,
      //   $parent,
      //   src,
      //   loading,
      //   error,
      //   Init
      // )
      // 现在只做了1:1显示缩略图的图像缩放,如果展示框不是1:1,需要判断class有没有非1:1的class再做判断
      const parentClassArray = el.parentElement.classList
      // console.log('parentClassArray', parentClassArray.value)
      // 矩形缩略图
      if (parentClassArray.value.includes('rectang')) {
        if (naturalWidth < naturalHeight) {
          el.style = 'max-width:100%'
        }
        if (naturalWidth > naturalHeight) {
          el.style = 'max-height:100%'
        }
        // 正方形缩略图
      } else {
        if (naturalWidth && naturalHeight && naturalWidth === naturalHeight) {
          el.style = 'max-width:100%;max-height:100%'
        }
        if (naturalWidth > naturalHeight) {
          el.style = 'max-height:100%'
        }
        if (naturalWidth < naturalHeight) {
          el.style = 'max-width:100%'
        }
        // 未检测到图片宽高时
        if (naturalWidth === 0 && naturalHeight === 0) {
          el.style = 'max-height:100%'
        }
      }
      // do something here
      // example for call LoadedHandler
      // LoadedHandler(el)
      // window.test2 = el
    },
    // loading(listender, Init) {
    //   console.log('loading')
    // },
    // error(listender, Init) {
    //   console.log('error')
    // }
  },
  // adapter: {
  //   loaded({
  //     bindType,
  //     el,
  //     naturalHeight,
  //     naturalWidth,
  //     $parent,
  //     src,
  //     loading,
  //     error,
  //     Init
  //   }) {
  //     // console.log('loaded', naturalWidth, naturalHeight)
  //     // console.log(
  //     //   'loaded-el',
  //     //   bindType,
  //     //   el,
  //     //   naturalHeight,
  //     //   naturalWidth,
  //     //   $parent,
  //     //   src,
  //     //   loading,
  //     //   error,
  //     //   Init
  //     // )
  //     // 现在只做了1:1显示缩略图的图像缩放,如果展示框不是1:1,需要判断class有没有非1:1的class再做判断
  //     // const parentClassArray =  el.parentElement.classList
  //     // console.log('parentClassArray',parentClassArray.value);
  //     if (naturalWidth === naturalHeight) {
  //       el.style = 'max-width:100%;max-height:100%'
  //     }
  //     if (naturalWidth > naturalHeight) {
  //       // el.height = '100%'
  //       el.style = 'max-height:100%'
  //     }
  //     if (naturalWidth < naturalHeight) {
  //       el.style = 'max-width:100%'
  //     }
  //     // do something here
  //     // example for call LoadedHandler
  //     // LoadedHandler(el)
  //     // window.test2 = el
  //   }
  //   // loading(listender, Init) {
  //   //   console.log('loading')
  //   // },
  //   // error(listender, Init) {
  //   //   console.log('error')
  //   // }
  // }
})
// }
